import { client } from '../lib/client';

// 퀵 배송
export const quickTempAPI = (data) => (
  client({
    url: '/v1/quick/temp',
    method: 'post',
    data
  }, true)
);

// 화물 배송
export const freightTempAPI = (data) => (
  client({
    url: '/v1/freight/temp',
    method: 'post',
    data
  }, true)
);

export const moveTempAPI = (data) => (
  client({
    url: '/v1/move/temp',
    method: 'post',
    data
  }, true)
);

export const orderCalAPI = (data) => (
  client({
    url: '/v1/order/cal',
    method: 'post',
    data
  }, true)
);

// 배너 조회
export const bannerSelAPI = () => (
  client({
    url: '/v1/banner/list',
  })
);

// 결제 완료 확인 — 아임포트 결제창 성공 콜백 뒤 서버가 결제를 검증하고 접수한다
export const paymentCompleteAPI = (data) => (
  client({
    url: '/v1/payment/complete',
    method: 'post',
    data
  }, true)
);
